// src/components/PermissionGuard.jsx
import React from 'react';
import { usePermissions } from '../context/PermissionsContext';

/**
 * مكون لحماية العناصر بناءً على الصلاحيات
 * يخفي أو يظهر المحتوى حسب صلاحيات المستخدم
 * 
 * @param {string} permission - الصلاحية المطلوبة (اختياري)
 * @param {Array} anyPermissions - قائمة صلاحيات، يكفي امتلاك أي منها (اختياري)
 * @param {Array} allPermissions - قائمة صلاحيات، يجب امتلاكها جميعاً (اختياري)
 * @param {React.ReactNode} fallback - محتوى بديل يظهر عند عدم وجود الصلاحية (اختياري)
 * @param {React.ReactNode} children - المحتوى المحمي
 */
const PermissionGuard = ({ 
  permission, 
  anyPermissions, 
  allPermissions, 
  fallback = null, 
  children 
}) => {
  const { hasPermission, hasAnyPermission, hasAllPermissions, loading } = usePermissions();

  // أثناء التحميل، يمكن إظهار محتوى فارغ أو loader
  if (loading) {
    return null;
  }

  // التحقق من الصلاحيات
  let hasAccess = true;

  if (permission) {
    hasAccess = hasPermission(permission);
  } else if (anyPermissions && anyPermissions.length > 0) {
    hasAccess = hasAnyPermission(anyPermissions);
  } else if (allPermissions && allPermissions.length > 0) {
    hasAccess = hasAllPermissions(allPermissions);
  }

  // إذا لم يكن لديه صلاحية، إظهار fallback أو لا شيء
  if (!hasAccess) {
    return fallback;
  }

  // إذا كان لديه الصلاحية، إظهار المحتوى
  return <>{children}</>;
};

export default PermissionGuard;
